import React, { useContext } from "react";
import LocalizationContext from "../../Localization/LanguageContext";
import { ILocalizationContext } from "../../Localization/Models/ILocalizationContext";
import { getLoginURL} from "../../Utils/getLoginURL";
import { AutoLink, Link } from "@saif/link";

const ErrorResources = () => {
    const { getValue, locale } = useContext(LocalizationContext) as ILocalizationContext;
    
    return (
        <div className="error-resources">
            {getValue('ErrorResources', 'Text1')}&nbsp;
            <Link href={getLoginURL(locale)}>{getValue('ErrorResources', 'Text2')}</Link>
            &nbsp;{getValue('ErrorResources', 'Text3')}&nbsp;
            <AutoLink type="phone" value={getValue('ErrorResources', 'Phone')}/>
            &nbsp;{getValue('ErrorResources', 'Text4')}
        </div>
    );
}

export default ErrorResources;